/*
 * @Author: your name
 * @Date: 2021-03-23 10:58:08
 * @LastEditTime: 2021-03-23 14:06:25
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /web-platform/src/utils/ant-utils.js
 */
// import { MessageBox } from 'element-ui'
import { Modal } from 'ant-design-vue'
import { isFunction } from 'lodash'

/**
 * 系统提示数字据字典
 */
const systemConfirmDict = {
  // 询比相关
  POST_INQUIRY_ORDER: '是否确定发布询比单',

  // 通用-报名
  SUBMIT_SIGN_UP: '是否提交报名信息',
  SUBMIT_QUOTE: '是否提交报价',
  SUBMIT_APPROVAL: '是否提交审核结果',

  // 通用-候选与成交
  ROUTER_LEAVE: '当前信息未保存，是否离开？',
  POST_CANDIDATE: '是否确定发布候选信息',
  POST_RESULT: '是否确定发布成交结果',

  // 通用-异常处理
  ABORTIVE: '是否确定流标',
  SUBMIT_CHANGE_NOTICE: '是否发布变更公告',
  SUBMIT_CLARIFICATION_FILE: '是否发布文件澄清',

  // 开票相关
  SAVE_ELECTRONIC_INVOICE: '是否保存电子发票信息',
  SAVE_PAPER_INVOICE: '是否保存纸质发票信息',

  // 通用-删除提示
  DELETE_PROJECT: '确定删除该项目吗？',
  DELETE_INQUIRY_ORDER: '确定删除该询比单吗?',
  DELETE_PRODUCT: '是否删除该产品',
  DELETE_BANNER: '是否删除该轮播图',
  DELETE_MATERIAL: '确定删除该品目吗？',
  DELETE_SELECTED_MATERIAL: '是否确定删除选中的品目',
  DELETE_SUPPLIER: '确定删除该供应商吗？',

  // 通用-邀请相关操作提示
  SEND_INVITE: '是否发送邀请',
  REJECT_INVITE: '确定拒绝该邀请？',

  // 用户操作使用
  DELETE_ACCOUNT: '确定删除用此账号？',
  OPEN_ACCOUNT: '确定启用该账号？',
  CLOSE_ACCOUNT: '确定停用该账号？',

  // 企业信息
  SUBMIT_COMPANY_AUDIT: '确定提交企业审核信息？'
}

/**
 * 统一的系统提示
 * @param {string|Function} message 提示信息
 * @param {string} title 提示标题
 * @param {string} confirmText 确定按钮文字
 * @param {string} cancelText 取消按钮文字
 * @returns {Promise<unknown>}
 */
export function systemConfirm(
  message,
  title = '系统提示',
  confirmText = '确 定',
  cancelText = '取 消',
  zIndex
) {
  return new Promise((resolve, reject) => {
    const tips = isFunction(message)
      ? message
      : systemConfirmDict[message] || message || ''
    // MessageBox.confirm(tips, title, {
    //   confirmButtonText: confirmText,
    //   cancelButtonText: cancelText,
    //   type: 'warning',
    //   dangerouslyUseHTMLString: true
    // })
    //   .then(() => resolve(true))
    //   .catch(() => resolve(false))
    Modal.confirm({
      okText: confirmText,
      cancelText: cancelText,
      title: title,
      content: tips,
      zIndex: zIndex || 9999,
      icon: h => <a-icon type='exclamation-circle' theme='filled' />,
      onOk: () => resolve(true),
      onCancel: () => resolve(false)
    })
  })
}
